export const LogoMark = ({ size = 40, className = "" }) => (
    <span
        className={`logo-tile ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
    >
        <img
            src="/eway-logo.jpg"
            alt=""
            width={size}
            height={size}
            className="h-full w-full object-cover"
            loading="eager"
        />
    </span>
);

export const Logo = ({ compact = false }) => (
    <span className="flex items-center gap-3" data-testid="brand-logo">
        <LogoMark size={compact ? 38 : 52} />
        <span className="flex flex-col leading-none">
            <span className="font-display text-xl font-black tracking-tight text-white">
                EWAY
            </span>
            <span className="font-mono text-[10px] font-semibold tracking-[0.32em] text-[#E61C24]">
                FIBER NET
            </span>
        </span>
    </span>
);
